import { guide } from 'api';
import { SET_GUIDE_PROPERTY, GET_DRIVER_GUIDE } from 'store/actions/guide';
import { SET_UI_PROPERTY } from 'store/actions/ui';

export default {
  [SET_GUIDE_PROPERTY]: ({ commit }, { field, value }) =>
    commit(SET_GUIDE_PROPERTY, {
      field,
      value
    }),

  [GET_DRIVER_GUIDE]: ({ commit }, carRegistration) =>
    new Promise((resolve, reject) => {
      guide.driverGuide(carRegistration).then(
        (response) => {
          const { data } = response;
          commit(SET_GUIDE_PROPERTY, { field: 'carRegistration', value: carRegistration });
          commit(SET_GUIDE_PROPERTY, { field: 'driverGuide', value: data });
          commit(`ui/${SET_UI_PROPERTY}`, { field: 'theme', value: data.theme }, { root: true });
          commit(
            `ui/${SET_UI_PROPERTY}`,
            { field: 'logoUrl', value: data.logoUrl },
            { root: true }
          );
          commit(
            `ui/${SET_UI_PROPERTY}`,
            { field: 'phoneNumber', value: data.phoneNumber },
            { root: true }
          );
          commit(
            `ui/${SET_UI_PROPERTY}`,
            { field: 'hashtag', value: data.hashtag },
            { root: true }
          );
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    })
};
